import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import config from '../../config';

function CategoryUpdate() {
    const { id } = useParams(); // Get the category ID from the URL
    const navigate = useNavigate();
    const [category, setCategory] = useState({
        name: '',
        description: ''
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
   

    useEffect(() => {
        const fetchCategoryDetails = async () => {
            try {
                const response = await axios.get(`${config.BASE_URL}/api/admin/categories/${id}`, { withCredentials: true });
                if (response.data.success && response.data.data) {
                    setCategory(response.data.data);
                }
            } catch (err) {
                setError('Failed to fetch category details');
            } finally {
                setLoading(false);
            }
        };

        fetchCategoryDetails();
    }, [id]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccessMessage('');

        try {
            const response = await axios.put(`${config.BASE_URL}/api/admin/categories/${id}`, category, {
                headers: {
                    'Content-Type': 'application/json',
                },
                withCredentials: true,
            });

            if (response.data.success) {
                setSuccessMessage('Category updated successfully!');
                // Optionally redirect after a delay
                setTimeout(() => {
                    navigate('/admin/category');
                }, 2000);
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Failed to update category');
        }
    }

    if (loading) {
        return (
            <div className="dashboard">
                <div className="container">
                    <p>Loading...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="dashboard update_detail_wrap">
            <div className="container">
                <h1 className="dash_title">Edit Category</h1>
                <div className="back_btn_wrap">
                    <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
                </div>
                {category ? (
                    <form onSubmit={handleFormSubmit}>
                        <div className="update_details_wrap">
                            <div className="form-group">
                                <label>Category Name</label>
                                <input
                                    type="text"
                                    value={category.name}
                                    onChange={(e) => setCategory({ ...category, name: e.target.value })}
                                    placeholder="Enter category name"
                                    required
                                />
                            </div>

                            <div className="form-group textareaField">
                                <label>Description</label>
                                <textarea
                                    name="description"
                                    value={category.description}
                                    onChange={(e) => setCategory({ ...category, description: e.target.value })}
                                    placeholder="Enter category description (optional)"
                                    rows="4"
                                />
                            </div>
                        
                            <div className="update_btn_wrap">
                                <button className="update_btn" type="submit">Update Category</button>
                            </div>
                            {successMessage && <p className="success-message">{successMessage}</p>}
                            {error && <p className="error-message">{error}</p>}
                        </div>
                    </form>
                ) : (
                    <h5>Category not found!</h5>
                )}
            </div>
        </div>
    ); 
}

export default CategoryUpdate;
